import { css } from '@emotion/react'

interface EnderecoNaoInformadoTextProps {
  text: string
}

export function EnderecoNaoInformadoText(props: Readonly<EnderecoNaoInformadoTextProps>) {
  const { text } = props

  return <span css={styles.root}>{text}</span>
}

const styles = {
  root: css`
    font-style: italic;
  `,
}
